var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCraneTruckSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 701 224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "CRANE TRUCK SMALL"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "CRANE TRUCK SMALL"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17 -37.9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.351,
    d: "M692.2 87.6c4.6 5.3-3.4 9.9-4.9 3.9-1.1-4.5-6.3-4.1-6.3-4.1",
    "data-name": "Path 1"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m486.5 75.7 5.5-12.3",
    "data-name": "Line 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m481.5 86.9 5-11.2",
    "data-name": "Line 2"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M509.4 184.7H426a6.283 6.283 0 0 1-6.3-6.6l2.9-79.6a10.378 10.378 0 0 1 10.4-10h69.4a10.378 10.378 0 0 1 10.4 10l2.9 79.6a6.344 6.344 0 0 1-6.3 6.6Z",
    "data-name": "Path 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M437.3 195.4h-13.2a.9.9 0 0 1-.9-.9v-8.9a.9.9 0 0 1 .9-.9h13.2a.9.9 0 0 1 .9.9v8.9a.9.9 0 0 1-.9.9Z",
    "data-name": "Path 3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M511.4 195.4h-13.2a.9.9 0 0 1-.9-.9v-8.9a.9.9 0 0 1 .9-.9h13.2a.9.9 0 0 1 .9.9v8.9a.9.9 0 0 1-.9.9Z",
    "data-name": "Path 4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M523.7 128.2H515a.945.945 0 0 1-1-1v-17.5a.945.945 0 0 1 1-1h8.7a.945.945 0 0 1 1 1v17.5a1 1 0 0 1-1 1Z",
    "data-name": "Path 5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M420.5 128.2h-8.7a.945.945 0 0 1-1-1v-17.5a.945.945 0 0 1 1-1h8.7a.945.945 0 0 1 1 1v17.5a1 1 0 0 1-1 1Z",
    "data-name": "Path 6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.1,
    cy: 7.1,
    r: 7.1,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 1",
    transform: "translate(461 47.5)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m474.2 51.7 202.3 30a4.394 4.394 0 0 1 3.7 5.2 4.38 4.38 0 0 1-5 3.5L472.7 60",
    "data-name": "Path 7"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m690.4 93.4.2 16.2-20.6 16.5",
    "data-name": "Path 8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m690.6 109.6 21.3 16.5",
    "data-name": "Line 3"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M707.9 128.9v8.2a2.671 2.671 0 0 1-2.4 2.8h-29.6a2.671 2.671 0 0 1-2.4-2.8v-8.2a2.671 2.671 0 0 0-2.4-2.8h-1.8a2.671 2.671 0 0 0-2.4 2.8v52.6a2.671 2.671 0 0 0 2.4 2.8H712a2.671 2.671 0 0 0 2.4-2.8v-52.6a2.671 2.671 0 0 0-2.4-2.8h-1.6a2.679 2.679 0 0 0-2.5 2.8Z",
    "data-name": "Path 9"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M463.5 59.9v28.4",
    "data-name": "Line 4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M472.6 59.9v28.4",
    "data-name": "Line 5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M419.5 137H516",
    "data-name": "Line 6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m422.6 97.3 21.3 2.1H492l20.8-2.1",
    "data-name": "Path 10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M420.4 153.7H435l6.5 11.3H420",
    "data-name": "Path 11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M515.1 153.7h-14.5l-6.5 11.3h21.4",
    "data-name": "Path 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M450.8 171.8h34",
    "data-name": "Line 7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M57.3 85.8c-2.7 3.8 1.3 6.4 2.4 2.3a3.958 3.958 0 0 1 3.5-3.1",
    "data-name": "Path 13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M126.9 51.5 65.1 82.3a1.145 1.145 0 0 0-.6 1.3l.3 1.3a1.164 1.164 0 0 0 1.6.8l64-28.7",
    "data-name": "Path 14"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 18.3,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 2",
    rx: 11,
    ry: 18.3,
    transform: "translate(159.2 165.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M243.3 184.2c-2.5 7.1-6.4 10.5-11.2 10.5-4.3 0-8.2-3.3-10.8-8.4",
    "data-name": "Path 15"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9,
    cy: 15,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 3",
    rx: 9,
    ry: 15,
    transform: "translate(48.4 162.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m196.2 121.3 70.1-1.9-10-29.7-68.3-5.4a1.63 1.63 0 0 0-1.7 2Z",
    "data-name": "Path 16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m174 98.2 5.4-.2a1.974 1.974 0 0 1 1.8 2.2l3 20.2c.1 1.5-1 2.6-2.1 2.3l-8.6-2.2a2.243 2.243 0 0 1-1.5-2.3l.2-17.9a2.072 2.072 0 0 1 1.8-2.1Z",
    "data-name": "Path 17"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 4",
    transform: "translate(126.9 47.1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m223.4 186.6-42.2-4.7",
    "data-name": "Line 8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m249.2 172.5 25.2-2.8",
    "data-name": "Line 9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.7,
    cy: 7.1,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 5",
    rx: 2.7,
    ry: 7.1,
    transform: "translate(54.7 170.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.4,
    cy: 8.9,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 6",
    rx: 3.4,
    ry: 8.9,
    transform: "translate(166.7 174.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M146 131.3H26.3a3.116 3.116 0 0 0-3.1 3.1v25l124 6.5.1-87 22.7.1",
    "data-name": "Path 18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m180.9 100.4 8.4-1.1",
    "data-name": "Line 10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m184.9 119.2 10.3-1.2",
    "data-name": "Line 11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M128.9 57.7V133",
    "data-name": "Line 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M137.8 57.7V133",
    "data-name": "Line 13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m120.1 87.1 6.9 18 .9-6-5-13.1a1.528 1.528 0 0 0-1.9-.9 1.631 1.631 0 0 0-.9 2Z",
    "data-name": "Path 19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m121.1 85.5-8.4-21.4",
    "data-name": "Line 14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M225.5 165.1h15.3l-6.1-11.8h-9.2l-13.2-6.8-4.4 10.9Z",
    "data-name": "Path 20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m291.9 147.7-7.1 2.3-5.2 12.6 12.2-3.1",
    "data-name": "Path 21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m159.1 178.1-5.6-.7 3.2-88.3a9.6 9.6 0 0 1 7.8-9.1l20.4-4 65.5 5.8c2.6.3 4 2.3 4.9 5.3l11 32.2 11 6.7c9.2 6.1 15.2 17.2 15.2 26.4v14.7c0 10.6-5.2 12.2-11.9 12.7l-57.9 6.7",
    "data-name": "Path 22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m149.3 166.1 5.1-.2",
    "data-name": "Line 15"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M318 6.5v150.6",
    "data-name": "Line 16"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "M313.5 7.8 318 0l4.5 7.8Z",
    "data-name": "Path 23"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m313.5 155.8 4.5 7.8 4.5-7.8Z",
    "data-name": "Path 24"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M519.6 176.3h175.3",
    "data-name": "Line 17"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m520.9 180.8-7.8-4.5 7.8-4.5Z",
    "data-name": "Path 25"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m693.6 180.8 7.7-4.5-7.7-4.5Z",
    "data-name": "Path 26"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m6.4 168.8 183.2 15.5",
    "data-name": "Line 18"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "M7.4 173.4 0 168.2l8.1-3.8Z",
    "data-name": "Path 27"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m187.9 188.6 8.2-3.8-7.4-5.1Z",
    "data-name": "Path 28"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m215 183.6 62.9-8.5",
    "data-name": "Line 19"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m216.9 187.9-8.3-3.4 7.1-5.5Z",
    "data-name": "Path 29"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m277.2 179.7 7.1-5.5-8.3-3.4Z",
    "data-name": "Path 30"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 126"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "var(--delivery-measurement-color)",
    "data-name": "Group 124",
    transform: "translate(-820 -6541)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 33,
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6541)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.798 6556.71a2 2 0 0 1 2.204-.8l20.574 5.853a2 2 0 0 1 .132 3.806l-32.568 11.848a2 2 0 0 1-2.344-3Z",
    "data-name": "Polygon 2"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "H,H m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(339.667 22.763)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "H,H m"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 128"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "var(--delivery-measurement-color)",
    "data-name": "Group 125",
    transform: "translate(-904 -6352.638)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.814 6547.788a2 2 0 0 1 .802 2.204l-5.854 20.574a2 2 0 0 1-3.806.132l-11.848-32.568a2 2 0 0 1 3-2.344Z",
    "data-name": "Polygon 2"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "W,W m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(252 214.362)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "W,W m"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 127",
    transform: "translate(-1095.911 -6352.638)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    fill: "var(--delivery-measurement-color)",
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "L,L m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(66.649 214.362)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "L,L m")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 129"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "var(--delivery-measurement-color)",
    "data-name": "Group 125",
    transform: "translate(532.094 180.851)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156.026,
    height: 33.49,
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(0 10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.313 2.755a2 2 0 0 1 3.4 0l6.914 11.194a2 2 0 0 1-1.7 3.051H71.099a2 2 0 0 1-1.7-3.051Z",
    "data-name": "Polygon 2"
  }))), /*#__PURE__*/React.createElement("text", {
    "data-name": "max. M,M m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(549.107 215.362)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "max. M,M m")), /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-measurement-color)",
    d: "M91.949 182.855a2 2 0 0 1 3.4 0l6.914 11.194a2 2 0 0 1-1.7 3.051H86.735a2 2 0 0 1-1.7-3.051Z",
    "data-name": "Polygon 3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCraneTruckSmall);
export default __webpack_public_path__ + "static/media/CraneTruckSmall.31cf56876aeeb0d2b4bd3b1cd9b763be.svg";
export { ForwardRef as ReactComponent };